import { render } from "./FooterWice.vue?vue&type=template&id=6d696603&scoped=true"
import script from "./FooterWice.vue?vue&type=script&lang=js"
export * from "./FooterWice.vue?vue&type=script&lang=js"

import "./FooterWice.vue?vue&type=style&index=0&id=6d696603&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d696603"]])

export default __exports__